// =============================================================================
// features/sales/campaigns/detail/components/MemberStatusBadge.tsx — Badge de
// status de UM membro da carteira (`campaign_members.status`) — vocabulário
// diferente de `CampaignStatusBadge` (status da campanha inteira, F35-S07).
// Badge (DS §9.5): status nunca depende só de cor.
// =============================================================================

import type { CampaignMemberStatus } from '@elemento/shared-schemas';
import * as React from 'react';

import { Badge } from '../../../../../components/ui/Badge';
import type { BadgeVariant } from '../../../../../components/ui/Badge';

const LABEL: Record<CampaignMemberStatus, string> = {
  pending: 'Pendente',
  available: 'Disponível',
  claimed: 'Em atendimento',
  waiting_callback: 'Aguardando retorno',
  completed: 'Concluído',
  blocked: 'Bloqueado',
  removed: 'Removido',
};

const VARIANT: Record<CampaignMemberStatus, BadgeVariant> = {
  pending: 'neutral',
  available: 'info',
  claimed: 'warning',
  waiting_callback: 'warning',
  completed: 'success',
  blocked: 'danger',
  removed: 'neutral',
};

export function MemberStatusBadge({ status }: { status: CampaignMemberStatus }): React.JSX.Element {
  return <Badge variant={VARIANT[status]}>{LABEL[status]}</Badge>;
}
